<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :z-index="zIndex"></loading>
    <b-modal id="modalDeleteEducation" ref="modalDeleteEducation" title="Confirm">
      <p>Do you really want to remove the registry?</p>
      <p><b>Original Title: </b> {{ education.courseName }}</p>
      <p><b>School/University: </b> {{ education.institution }}</p>
      <template slot="modal-footer">
          <b-button variant="primary" class="mr-2" @click="confirmDeleteEducation">Confirm</b-button>
          <b-button variant="secondary" @click="hideModalDeleteEducation">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalEducation" ref="modalEducation" size="lg" :title="(newEducation) ? 'Add education' : 'Edit education'">
      <b-row>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Original Title <span v-if="checkLabelRequired('courseName')" class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-form-input v-model="education.courseName" :state="$v.education.courseName.$dirty ? !$v.education.courseName.$error : null" type="text" class="form-control" maxlength="100"/>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>School/University <span v-if="checkLabelRequired('institution')" class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-form-input v-model="education.institution" :state="$v.education.institution.$dirty ? !$v.education.institution.$error : null" type="text" class="form-control" maxlength="50"/>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Academic type <span v-if="checkLabelRequired('academicTypeId')" class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-form-select v-model="education.academicTypeId" :state="$v.education.academicTypeId.$dirty ? !$v.education.academicTypeId.$error : null" :options="academycTypes" value-field="id" text-field="description"></b-form-select>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Country <span v-if="checkLabelRequired('countryId')" class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-form-select v-model="education.countryId" :state="$v.education.countryId.$dirty ? !$v.education.countryId.$error : null" :options="countries" value-field="id" text-field="name"></b-form-select>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <div class="form-group">
            <label>Start Date <span v-if="checkLabelRequired('startDate')" class="text-danger">*</span></label>   
            <b-input-group class="mb-3">
              <b-form-input 
                id="startDate" 
                v-model="formatedStartDate" 
                v-mask="['##/##/####']" 
                :state="validateState('startDate')" 
                type="text" 
                placeholder="DD/MM/YYYY" 
                autocomplete="off"
                @blur="onBlurStartDate">
              </b-form-input>
              <b-input-group-append>
                <b-form-datepicker 
                  v-model="education.startDate" 
                  button-only 
                  close-button 
                  locale="pt-BR" 
                  right  
                  :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }" 
                  @context="onStartDateChange"
                  @blur="onBlurStartDate">
                </b-form-datepicker>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="2" lg="2" xl="2">
          <div class="form-group">
            <label>On Going</label>   
            <div class="input-group"> 
              <b-form-checkbox v-model="education.onGoing" :value="true"></b-form-checkbox>
            </div>
          </div>
        </b-col>
        <b-col v-if="!education.onGoing" cols="12" sm="12" md="4" lg="4" xl="4">
          <div class="form-group">
            <label>End Date <span class="text-danger">*</span></label>   
            <b-input-group class="mb-3">
              <b-form-input id="endDate" 
                v-model="formatedEndDate" 
                v-mask="['##/##/####']" 
                :state="validateState('endDate')" 
                type="text" 
                placeholder="DD/MM/YYYY" 
                autocomplete="off"
                @blur="onBlurEndDate">
              </b-form-input>
              <b-input-group-append>
                <b-form-datepicker 
                  v-model="education.endDate" 
                  button-only 
                  close-button 
                  locale="pt-BR" 
                  right  
                  :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }" 
                  @context="onEndDateChange"
                  @blur="onBlurEndDate"></b-form-datepicker>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
          <div class="form-group">
            <label>Description <span v-if="checkLabelRequired('courseDescription')" class="text-danger">*</span></label>   
            <div class="input-group"> 
              <b-form-textarea id="textarea-default" v-model="education.courseDescription" :state="$v.education.courseDescription.$dirty ? !$v.education.courseDescription.$error : null" maxlength="250"></b-form-textarea>
            </div>
          </div>
        </b-col>
      </b-row>
      <template slot="modal-footer">
          <b-button variant="primary" class="mr-2" @click="saveEducation">Save</b-button>
          <b-button variant="secondary" @click="hideModalEducation">Close</b-button>
      </template>
    </b-modal>
    <div class="card-body">
      <h5 class="card-title">Education</h5>
      <div class="row">
        <div class="col-md-12">
          <b-table hover :items="educationItems" :fields="educationFields">
            <template v-slot:cell(Options)="row">
              <b-button v-b-tooltip.hover title="Edit" variant="primary" size="xs" @click="editEducation(row.item)"><i class="far fa-edit"></i></b-button>
              <b-button v-b-tooltip.hover title="Remove" variant="danger" size="xs" class="ml-2" @click="deleteEducation(row.item)"><i class="far fa-trash-alt"></i></b-button>
            </template>
            <template v-slot:cell(courseDescription)="row">
              <b-button v-b-popover.hover="{ title: 'Description of course', content: row.item.courseDescription }" size="xs"><i class="mdi mdi-information-outline"></i></b-button>
            </template>
            <template v-slot:cell(period)="row">
              <b>Start</b> {{ row.item.startDate | formatDate }} <span v-if="row.item.endDate"><b>End</b> {{ row.item.endDate | formatDate }}</span> <span v-if="row.item.onGoing"><b>On Going</b></span>
            </template>
          </b-table>
          <b-button variant="primary" @click="addEducation">Add education</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from '@src/app.config'
import { authMethods } from '@state/helpers'
import loading from 'vue-loading-overlay'
import axios from 'axios'
import 'vue-loading-overlay/dist/vue-loading.css'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';

var qs = require('qs')

export default {
  components: { loading },
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    agency: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    id: { type: String, default: () => ({}) }
  },
  data () {
    return {
      CurriculumId: this.id,
      GeneralData: {},
      educationFields: [
        {
          key: 'courseName',
          label: 'Original Title'
        },
        {
          key: 'courseDescription',
          label: 'Description'
        },
        {
          key: 'institution',
          label: 'School/University'
        },
        {
          key: 'period',
          label: 'Period'
        },
        {
          key: 'academicType.description',
          label: 'Academic Type'
        },
        {
          key: 'country.name',
          label: 'Country'
        },
        {
          key: 'Options',
          label: 'Options',
          thStyle: {width: '120px !important'}
        }
      ],
      educationItems: [],
      newEducation: false,
      education: {},
      academycTypes: [],
      countries: [],
      isLoading: false,
      fullPage: false,
      zIndex: 9999,
      requiredFields: [],
      momentFormat: {
        stringify: (date) => {
          return date ? moment(date).format('DD/MM/YYYY') : ''
        },
        parse: (value) => {
          return value ? moment(value, 'DD/MM/YYYY').toDate() : null
        }
      },
      formatedStartDate: null,
      formatedEndDate: null
    }
  },
  validations() {
    return {
      education: {
        courseName: this.checkDynamicRequired('courseName'),
        institution: this.checkDynamicRequired('institution'),
        academicTypeId: this.checkDynamicRequired('academicTypeId'),
        countryId: this.checkDynamicRequired('countryId'),
        startDate: this.checkDynamicRequired('startDate'),
        courseDescription: this.checkDynamicRequired('courseDescription'),
        endDate: !this.education.onGoing ? { required } : {}
      }
    }
  },
  watch: {
    'education.onGoing': {
      handler: function (value) {
        if (value) {
          this.education.endDate = null
        }
      }
    }
  },
  created () {
    this.loadCountries()
  },
  methods: {
    ...authMethods,
    loadRequiredFields () {
      axios.get(`${appConfig.apiUrl}required-fields/${this.agency.id}/only/education`,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.requiredFields = response.data
      })
      .finally(() => {
        this.loadEducation()
      })
    },
    checkDynamicRequired (field) {
      if (this.requiredFields.find(f => f.aliasId === field && f.selected === true)) {
        return { required }
      }
      return {}
    },
    checkLabelRequired (field) {
      if (this.requiredFields.find(f => f.aliasId === field && f.selected === true)) {
        return true
      }
      return false
    },
    validateState (name) {
      const { $dirty, $error } = this.$v.education[name];
      return $dirty ? !$error : null;
    },
    formatSaveDate(date) {
      return date ? date.toDateString() : null
    },
    loadCountries () {
      this.isLoading = true
      axios.get(appConfig.apiUrl + 'country',
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.countries = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error})
      })
      .finally(() => {
        this.loadAcademicTypes()
      })
    },
    loadAcademicTypes () {
      axios.get(appConfig.apiUrl + 'academic/types',
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.academycTypes = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
      .finally(() => {
        this.loadRequiredFields()
      })
    },
    loadEducation () {
      axios.get(`${appConfig.apiUrl}academic/curriculum/${this.CurriculumId}`,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        if(response.data) {
          this.educationItems = response.data
          this.isLoading = false
        }
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    saveEducation () {
      this.$v.education.$touch()
      if (this.$v.education.$anyError) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.'});
        return
      }

      if (this.education.endDate) {

        var thisEndDate = moment(this.education.endDate).toDate()
        var thisStartDate = moment(this.education.startDate).toDate()
       
        if (thisEndDate < thisStartDate) {
          this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'End date cannot be less than the start date.'});
          return
        }
      }

      if (!this.education.endDate && !this.education.onGoing) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'Please inform the end date or on going.'});
        return
      }

      axios.post(appConfig.apiUrl + 'academic/save',
        qs.stringify(this.education),
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Saved Successful.'});
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.isLoading = false
          this.loadEducation()
          this.$emit('reload-curriculum')
          this.hideModalEducation()
        })
    },
    editEducation (item) {
      this.newEducation = false
      this.education = item
      this.$refs['modalEducation'].show()
    },
    deleteEducation (item) {
      this.education = item
      this.$refs['modalDeleteEducation'].show()
    },
    addEducation () {
      this.newEducation = true
      this.education = {
        curriculumId: this.CurriculumId
      }
      this.$refs['modalEducation'].show()
    },
    hideModalDeleteEducation () {
      this.$refs['modalDeleteEducation'].hide()
    },
    hideModalEducation () {
      this.$refs['modalEducation'].hide()
      this.$v.education.$reset()
    },
    confirmDeleteEducation () {
      this.isLoading = true
      axios.delete(appConfig.apiUrl + `academic/${this.education.id}`,
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Deleted Successful.'});
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.loadEducation()
          this.isLoading = false
          this.$emit('reload-curriculum')
          this.hideModalDeleteEducation()
        })
    },
    onStartDateChange (ctx) {
      if(ctx.selectedDate) {
        this.formatedStartDate = ctx.selectedFormatted
      } else {
        this.formatedStartDate = null
      }
      
    },
    onEndDateChange (ctx) {
      if(ctx.selectedDate) {
        this.formatedEndDate = ctx.selectedFormatted
      } else {
        this.formatedEndDate = null
      }      
    },
    onBlurStartDate(ctx) {
      if (ctx) {
        this.education.startDate = moment(ctx.target.value, 'DD/MM/YYYY').toDate()	
      }

    },
    onBlurEndDate(ctx) {
      if (ctx) {
        this.education.endDate = moment(ctx.target.value, 'DD/MM/YYYY').toDate()
      }
    }
  }
}
</script>
